// ISSUE-868. The confirm gate names the games in the outstanding round, so a
// Commissioner asked to confirm or wait can see what they are choosing about.
// It is one `/event/detail-get` per game rather than one batch read, because
// the only batch event read on the platform lives in the internal zone that
// `apps/app` may not call, so a child component per event id is the one shape
// that keeps a generated react-query hook per call. A game whose read has not
// landed, or failed, renders no row on purpose: a slow or broken enrichment
// read must never block or hide the decision the gate is asking for.

import { useEventDetailGet } from "@sportsmet/events-sdk/private";
import type { ReactNode } from "react";

import { resolveViewerTimeZone } from "../scores/viewerTimeZone";
import { buildOutstandingGameLine } from "./confirmGateCopy";

export type typeConfirmGateOutstandingGamesProps = {
  eventIds: readonly string[];
};

const ConfirmGateOutstandingGameRow = ({
  eventId,
}: {
  eventId: string;
}): ReactNode => {
  const timeZone = resolveViewerTimeZone();
  const detail = useEventDetailGet({ eventId, timeZone });
  const data = detail.data?.data ?? null;
  if (data === null) return null;
  return (
    <li
      data-testid="confirm-gate-outstanding-game"
      data-event-id={eventId}
      className="text-caption text-ink-secondary"
    >
      {buildOutstandingGameLine({
        awayName: data.away.name,
        homeName: data.home.name,
      })}
    </li>
  );
};

export const ConfirmGateOutstandingGames = ({
  eventIds,
}: typeConfirmGateOutstandingGamesProps): ReactNode => {
  if (eventIds.length === 0) return null;
  return (
    <ul
      data-testid="confirm-gate-outstanding-games"
      className="flex flex-col gap-1"
    >
      {eventIds.map((eventId) => (
        <ConfirmGateOutstandingGameRow key={eventId} eventId={eventId} />
      ))}
    </ul>
  );
};
